import { A11yModule } from "@angular/cdk/a11y";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, ViewChild, Input } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatRippleModule, MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatAccordion, MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router, RouterModule } from "@angular/router";
import { Roles } from "@models/base/identificadores.model";
import { Country, PaisDto } from "@models/pais/paisDto.model";
import { PersonaDetailDto } from "@models/persona/personaDetailDto.model";
import { RolDto } from "@models/seguridad/roles/rolDto.model";
import { CreateUsuarioRequest } from "@models/usuario/createUsuarioRequest.model";
import { UsuarioDto } from "@models/usuario/usuarioDto.model";
import { LoginService } from "@services/login/login.service";
import { PaisService } from "@services/pais/pais.service";
import { PaisesService } from "@services/pais/paises.service";
import { PasswordStrengthService } from "@services/passwordStrengthService/passwordStrengthService.service";
import { SnackBarService } from "@services/snackBar/snack-bar-service.service";
import { UsuarioService } from "@services/usuario/usuario.service";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { Observable, startWith, map } from "rxjs";
import { AuthLayoutComponent } from "../auth-layout/auth-layout.component";
import { PasswordStrengthDirective } from "@directives/passwordStrength.directive";



@Component({
  standalone: true,
   imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule,  A11yModule, CommonModule, MatExpansionModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, MatTabsModule, MatCheckboxModule, MatAutocompleteModule, MatChipsModule, MatTabsModule, DragDropModule, MatSidenavModule,MatListModule,AuthLayoutComponent,RouterModule,PasswordStrengthDirective,PasswordStrengthDirective],
  selector: 'app-form-usuario-registro',
  templateUrl: './form-usuario-registro.component.html',
  styleUrls: ['./form-usuario-registro.component.css'],

})
export class FormUsuarioRegistroComponent {

  hide = true;
  @ViewChild(MatAccordion) accordion: MatAccordion = new MatAccordion;
  @Input() personaId!: number;
  public personaControl = new FormControl();
  titulo: string = '';
  subMenuActive: boolean = false;
  stringObject: any;
  stringJson: any;
  usuarioForm: FormGroup;
  public personaDetailDto: PersonaDetailDto = new PersonaDetailDto;
  public UsuarioDto: UsuarioDto = new UsuarioDto;
  isEdition: boolean = false;
  submitted = false;
  parametro: string = '';
  createUsuarioRequest: CreateUsuarioRequest = new CreateUsuarioRequest;
  idUsuario!: number;
  formBuilder: FormBuilder = new FormBuilder;
  userSession!: UsuarioDto;
  roles!: RolDto[];
  paises!: Country[];
  isLoading: boolean = false;
  get f() { return this.usuarioForm.controls; }
  possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-)(*&%$#@!";
  lengthOfCode = 12;
  isDisabled: boolean = true;
  filteredCountries!: Observable<Country[]>;
  countryControl = new FormControl('');
  passwordStrength: any = null;

  constructor(
    //private UsuarioService: UsuarioService,
    private router: Router,
    public dialog: MatDialog,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private paisesService: PaisesService,
    private usuarioService: UsuarioService,
    private passwordStrengthService: PasswordStrengthService,
    private http: HttpClient
  ) {
    const phoneRegex = /^\+?\d{1,4}?[ -.]?\(?\d{1,4}\)?[ -.]?\d{1,9}([ -.]?\d{1,9})?$/;

    this.usuarioForm = this.formBuilder.group({
      Nombre: ['', Validators.compose([Validators.required])],
      Apellido: ['', Validators.compose([Validators.required])],
      Correo: ['', Validators.compose([Validators.required])],
      Telefono: ['', Validators.compose([Validators.required, Validators.pattern(phoneRegex)],)],
      Pais: ['', Validators.compose([Validators.required])],
      ClaveNueva: ['', Validators.compose([Validators.required, Validators.maxLength(100), Validators.minLength(8)])],
    })


  }


  ngOnInit(): void {
    // Valores de ejemplo
  this.usuarioForm.patchValue({
    Nombre: 'Juan',
    Apellido: 'Pérez',
    Correo: 'juan.perez@example.com',
    Telefono: '+54 9 341 1234567',
    Pais: 'Argentina',
    ClaveNueva: 'ClaveSegura123'
  });
    this.getCountries();

  }

  private filterCountries(value: string): Country[] {
    const filterValue = value.toLowerCase();
    return this.paises.filter(country =>
      country.name.common.toLowerCase().includes(filterValue)
    );
  }



  getCountries() {
    this.spinner.show('spListadoPaises')
    this.paisesService.getCountriesObservable()
      .subscribe(
        data => {
          this.spinner.hide('spListadoPaises')
          this.paises = data

          this.filteredCountries = this.usuarioForm.controls["Pais"].valueChanges.pipe(
            startWith(''),
            map(value => this.filterCountries(value || ''))
          );

        },
        error => {
          this.spinner.hide('spListadoPaises')
          this.snackBar.showError(error, "Error");
        })
  }

  setSelectedCountry(country: string) {
    this.usuarioForm.get('Pais')!.setValue(country);
    // Llamamos a onCountryChange para actualizar el campo 'Telefono'
    this.onCountryChange(country);
  }


  onPasswordInput() {
    const password = this.usuarioForm.controls["ClaveNueva"].value
    this.passwordStrength = this.passwordStrengthService.evaluatePasswordStrength(password);

    // Agregar clase para cambiar el color de la barra de progreso según la seguridad
    if (this.passwordStrength.progress <= 25) {
      this.passwordStrength.class = 'low';
    } else if (this.passwordStrength.progress <= 50) {
      this.passwordStrength.class = 'medium';
    } else {
      this.passwordStrength.class = 'high';
    }
  }

  // Método para actualizar el teléfono con el código del país seleccionado
  onCountryChange(country: string) {
    const paisSeleccionado = this.paises.find(p => p.name.common === country);
    if (paisSeleccionado) {
      this.usuarioForm.patchValue({
        Telefono: paisSeleccionado.idd?.root + paisSeleccionado.idd?.suffixes[0] + ' '
      });
    }
  }

  makeRandom(lengthOfCode: number, possible: string) {
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  onSubmit() {
    if (this.usuarioForm.valid)
      this.isLoading = true;
    this.spinner.show("spUsuarioCreate");
    if (this.usuarioForm.valid == true) {
      this.setCreateUsuarioRequest();
      this.usuarioService.register(this.createUsuarioRequest)
        .subscribe(
          data => {
            this.isLoading = false;
            this.spinner.hide("spUsuarioCreate");
            this.idUsuario = data.id
            this.snackBar.showSuccess("Tu usuario ha sido creado correctamente. En breve recibirás un código en tu correo para validar tu cuenta y avanzar al siguiente paso.", "Exito");
            const correo = this.usuarioForm.controls['Correo'].value;
            const contraseña = this.usuarioForm.controls['ClaveNueva'].value;
            this.router.navigate(['/verificarCorreo'], { queryParams: { correo: correo, contraseña: contraseña, idUsuario: this.idUsuario } });

          },
          error => {
            this.isLoading = false;
            this.spinner.hide("spUsuarioCreate");
            this.snackBar.showError(error, "Error");
          })

    }

  }
  cambiarPassword() {
    this.submitted = true;
  }

  generarClaveAleatoria() {
    this.usuarioForm.controls["ClaveNueva"].setValue(this.makeRandom(this.lengthOfCode, this.possible))
  }


  setCreateUsuarioRequest() {
    this.createUsuarioRequest = new CreateUsuarioRequest();
    this.createUsuarioRequest.userName = this.usuarioForm.controls['Correo'].value;
    this.createUsuarioRequest.nombre = this.usuarioForm.controls['Nombre'].value;
    this.createUsuarioRequest.apellido = this.usuarioForm.controls['Apellido'].value;
    this.createUsuarioRequest.correo = this.usuarioForm.controls['Correo'].value;
    this.createUsuarioRequest.telefono = this.usuarioForm.controls['Telefono'].value;
    this.createUsuarioRequest.password = this.usuarioForm.controls['ClaveNueva'].value;
    this.createUsuarioRequest.idRol = Roles.Administradores
    this.createUsuarioRequest.changePassword = false;
    this.createUsuarioRequest.activo = true
  }



  onCancel() {
    this.usuarioForm.reset();
    this.router.navigate(["/usuarios"])
  }

  trackByItems(index: number, item: any): any { return item; }

}
